import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, formatDistanceToNow } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num: number | null | undefined): string {
  if (num === null || num === undefined) return "0";
  if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
  if (num >= 1000) return (num / 1000).toFixed(1) + "K";
  return num.toString();
}

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return "Unknown date";
  try {
    const date = new Date(dateString);
    // If it's within the last 7 days, show relative time
    if (Date.now() - date.getTime() < 7 * 24 * 60 * 60 * 1000) {
      return formatDistanceToNow(date, { addSuffix: true });
    }
    return format(date, "MMM d, yyyy");
  } catch {
    return "Invalid date";
  }
}

export function getPlatformColor(platform: string) {
  if (platform.toLowerCase() === "tiktok") return "text-teal-400 border-teal-400/30 bg-teal-400/10";
  if (platform.toLowerCase() === "instagram") return "text-pink-400 border-pink-400/30 bg-pink-400/10";
  return "text-blue-400 border-blue-400/30 bg-blue-400/10";
}
